import { useState } from 'react';
import { Pane, TextInputField, Button, toaster, Text, IconButton, RemoveIcon } from 'evergreen-ui';
import { updateVolunteer, uploadVolunteerDocument, deleteVolunteerDocument } from '../services/volunteersServices';
import FileUploaderMultipleUploadDemo from '../commons/FileUploaderMultipleUploadDemo';

const EditVolunteerForm = ({ volunteer, onClose, fetchVolunteers }) => {
    const [formData, setFormData] = useState({
        id: volunteer.id,
        nome: volunteer.nome,
        cognome: volunteer.cognome,
        data_nascita: volunteer.data_nascita
    });

    const [filesToUpload, setFilesToUpload] = useState([]);
    const [documents, setDocuments] = useState(volunteer.documents || []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleDeleteDoc = async (docId) => {
        try {
            const res = await deleteVolunteerDocument(docId);
            if (res && res.success) {
                setDocuments(prev => prev.filter(doc => doc.id !== docId));
                toaster.success('Documento eliminato con successo');
            } else {
                toaster.danger('Errore durante l\'eliminazione del documento');
            }
        } catch (error) {
            console.error(error);
            toaster.danger('Errore imprevisto durante l\'eliminazione del documento');
        }
    };

    const handleSave = async () => {
        try {
            const result = await updateVolunteer(formData);
            if(result && result.success) {
                
                // Upload files if any
                if (filesToUpload.length > 0) {
                    for (const file of filesToUpload) {
                        await uploadVolunteerDocument(volunteer.id, file);
                    }
                }

                toaster.success('Volontario aggiornato correttamente.');
                fetchVolunteers();
                onClose();
            } else {
                toaster.danger('Errore aggiornamento volontario.');
            }
        } catch (e) {
            toaster.danger('Chiamata fallita per aggiornamento volontario.');
        }
    };

    return (
        <Pane>
            <Pane display="flex" flexDirection="column" gap={16} marginBottom={24}>
                <TextInputField
                    label="Nome"
                    name="nome"
                    value={formData.nome}
                    onChange={handleChange}
                    marginBottom={0}
                    autoFocus
                />
                <TextInputField
                    label="Cognome"
                    name="cognome"
                    value={formData.cognome}
                    onChange={handleChange}
                    marginBottom={0}
                />
                <TextInputField
                    label="Data di Nascita"
                    name="data_nascita"
                    type="date"
                    value={formData.data_nascita}
                    onChange={handleChange}
                    marginBottom={0}
                />

                <Pane borderTop="muted" paddingTop={16} marginTop={8}>
                    <Text weight={600} marginBottom={8} display="block">Documenti Allegati:</Text>
                    {documents.length > 0 ? (
                        <Pane display="flex" flexDirection="column" gap={8} marginBottom={16}>
                            {documents.map(doc => (
                                <Pane key={doc.id} display="flex" alignItems="center" justifyContent="space-between" width="100%">
                                    <Text overflow="hidden" whiteSpace="nowrap" textOverflow="ellipsis">
                                        <a href={doc.file_url} target="_blank" rel="noreferrer">{doc.file_name}</a>
                                    </Text>
                                    <IconButton icon={RemoveIcon} intent="danger" size="small" appearance="minimal" onClick={() => handleDeleteDoc(doc.id)} />
                                </Pane>
                            ))}
                        </Pane>
                    ) : (
                        <Text color="muted" marginBottom={16} display="block">Nessun documento allegato.</Text>
                    )}

                    <Text weight={600} marginBottom={8} display="block">Aggiungi nuovi documenti:</Text>
                    <FileUploaderMultipleUploadDemo onFilesChange={setFilesToUpload} />
                </Pane>
            </Pane>
            <Pane display="flex" justifyContent="flex-end" gap={16}>
                <Button onClick={onClose}>Annulla</Button>
                <Button appearance="primary" intent="success" onClick={handleSave}>Salva</Button>
            </Pane>
        </Pane>
    );
};

export default EditVolunteerForm;